import { connect } from "react-redux";
import MailFlowsComponent from "../../Components/MailFlows/MailFlowsComponent";

const mapStateToProps = (state) => ({
  ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
  // Les files servent à alimenter les listes déroulantes de routage. Elles sont filtrées sur
  // `channels.mail` dans le composant : proposer une file voix laisserait configurer un
  // routage que la file refusera ensuite, sans que l'administrateur en soit averti.
  QUEUES: state.reducer.QUEUES,
  SCOPES_NAMES: state.reducer.SCOPES_NAMES,
});

export default connect(mapStateToProps)(MailFlowsComponent);
